RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _, moment, formatter) {

    'use strict';

    function formatDate(date) {
        // moment.unix interprets the date as milliseconds since `Jan 1 1970 12AM UTC`, but isUTC is false.
        return moment.unix(date).utc().format('MMMM DD, YYYY');
    }

    function invoicePeriod(start, end) {
        return `${formatDate(start)} - ${formatDate(end)}`;
    }

    function formatCurrency(amountInCents) {
        const sign = (amountInCents < 0 ? '-' : '');
        return `${sign}$${(Math.abs(amountInCents) / 100.0).toFixed(2)}`;
    }

    function discountDescription(percentOff, durationInMonths) {
        let description = `${percentOff}% off`;
        if (_.isFinite(durationInMonths)) {
            description += ` for ${formatter.formatLabeledNumber('month', 'months', durationInMonths)}`;
        }

        return description;
    }

    // This function exists as there's no good way in the stripe api to determine if a proration invoice item had a
    // discount applied. Potentially we could try to replicate stripe's math or look at the previous invoice to see
    // if a discount existed then. This seemed like the least worst solution.
    //
    // Some example strings:
    // "Remaining time on Pro Plus after 01 Oct 2014"
    // "Unused time on Pro Plus (with 50% off) after 14 May 2014"
    // "Unused time on Pro after 01 Oct 2014"
    // "Remaining time on Pro Plus after 01 Oct 2014"
    function extractDiscountString(description) {
        const discountRegexp = /(\(with[^\)]+\)) after/;
        const matches = description.match(discountRegexp);
        if (matches && matches.length >= 2) {
            return matches[1];
        } else {
            return null;
        }
    }

    function lineItemDescription(lineItem) {
        let description = lineItem.description;

        if (lineItem.plan) {
            const planName = (lineItem.plan.statement_descriptor ? lineItem.plan.statement_descriptor : lineItem.plan.name);

            if (planName) {
                const isProration = Boolean(lineItem.proration);

                if (isProration) {

                    const discountString = extractDiscountString(lineItem.description);
                    const prorationDate = (_.isEmpty(lineItem.period) ? undefined : lineItem.period.start);
                    const isCredit = (lineItem.amount < 0);

                    if (isCredit) {
                        description = `Unused time on ${planName}`;
                    } else {
                        description = `Remaining time on ${planName}`;
                    }

                    if (discountString) {
                        description += ` ${discountString}`;
                    }

                    if (prorationDate) {
                        description += ` after ${formatDate(prorationDate)}`;
                    }
                } else {
                    if (!_.isEmpty(lineItem.period) && Boolean(lineItem.period.start) && Boolean(lineItem.period.end)) {
                        description = `${planName} for ${invoicePeriod(lineItem.period.start, lineItem.period.end)}`;
                    } else {
                        description = planName;
                    }
                }

            }
        }

        // stripe didn't give us a description or a plan with a plan name.
        if (!description) {
            description = 'Charge';
            if (!_.isEmpty(lineItem.period) && Boolean(lineItem.period.start) && Boolean(lineItem.period.end)) {
                description += ` for ${invoicePeriod(lineItem.period.start, lineItem.period.end)}`;
            }
        }

        return description;
    }

    function lineItems(lineItemData) {
        return lineItemData.map(function (lineItem) {
            return _.tap({
                description: lineItem.description,
                period: invoicePeriod(lineItem.period.start, lineItem.period.end),
                subtotal: formatCurrency(lineItem.amount)
            }, function (presentedLineItem) {
                presentedLineItem.description = lineItemDescription(lineItem);
            });
        });
    }

    models.presentInvoice = function (invoiceData) {
        return _.tap({
            invoiceDate: formatDate(invoiceData.period_end),
            invoiceNumber: invoiceData.number,
            subtotal: formatCurrency(invoiceData.subtotal),
            discount: formatCurrency(invoiceData.subtotal - invoiceData.total),
            hasTax: Boolean(invoiceData.tax),
            tax: formatCurrency(invoiceData.tax),
            total: formatCurrency(invoiceData.total),
            startingBalancePresent: Boolean(invoiceData.starting_balance),
            startingBalance: formatCurrency(invoiceData.starting_balance),
            paid: invoiceData.paid,
            paidAmount: formatCurrency(invoiceData.amount_due),
            lineItems: lineItems(invoiceData.lines.data),
            chargeDetails: invoiceData.chargeDetails,
            discountPresent: false
        }, function (presentedInvoice) {

            if (invoiceData.discount && invoiceData.discount.coupon) {
                const couponInfo = invoiceData.discount.coupon;
                presentedInvoice.discountPresent = true;
                presentedInvoice.discountDescription = discountDescription(couponInfo.percent_off, couponInfo.duration_in_months);
            }

            if (invoiceData.tax && invoiceData.tax_details) {
                const state = _.get(invoiceData, ['tax_details', 'effectiveTaxRateData', 'geoState']);
                const effectiveTaxRate = _.get(invoiceData, ['tax_details', 'effectiveTaxRate']);
                presentedInvoice.taxDescription = `${effectiveTaxRate}%${state === 'TX' ? `; reflects that data processing services are 80% taxable in Texas at ${Number((effectiveTaxRate / 0.8).toFixed(4))}%` : ''}`;
            }
        });
    };

}, window.moment, RivalIQ.formatter);
